import "./index.scss";
import { Variables, sameDate, createDate, formatDate,MonthsBetw } from "../../../utils";
import Mixins from "../../mixins";

export default {
  name: Variables.name.ganttHeader,

  props: {},

  beforeCreate() {},

  created() {},

  beforeMount() {},

  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  inject: ["pd", "gd"],

  mixins: [Mixins],

  data() {
    return {
      curIndex:0,
    };
  },

  computed: {
    /**
     * @returns 箭头宽度
     */
    arrowWidth: function() {
      let v = this.colWidth;
      if (this.colWidth > 50) {
        v = 50;
      }
      return v;
    },
    /**
     * @returns 两个日期间相差的月份
     */
    diffMonth:function() {
      return MonthsBetw(this.gd.start,this.gd.end)
    }
    
  },

  watch: {},

  methods: {},

  components: {},

  render(h) {
    let a=0;
    return h(
      "div",
      {
        class: {
          "gt-gantt-header": true,
          "gt-noselect": true,
          "gt-header-border-dark": this.pd.dark,
          "gt-header-bg-dark": this.pd.dark
        },
        style: {
          "--header-height": `${this.pd.headerHeight}px`,
          "background-color": `${
            this.pd.ganttOptions[Variables.key.header][Variables.key.bgColor]
          }`,
          "border-color": `${
            this.pd.ganttOptions[Variables.key.header][
              Variables.key.borderColor
            ]
          }`,
          color: `${
            this.pd.ganttOptions[Variables.key.header][Variables.key.textColor]
          }`
        }
      },
      this.pd.ganttHeaders
        .map(item => {
          if(sameDate(item, this.gd.start) || createDate(item).getDate() === 1){
            this.curIndex=a
            a=0;
          }
          a++;
          return h(
            "div",
            {
              class: {
                "gt-gantt-header-chunk": true,
                "gt-header-border-dark": this.pd.dark
              },
              style: {
                width: `${this.colWidth}px`,
                "border-color": `${
                  this.pd.ganttOptions[Variables.key.header][
                    Variables.key.borderColor
                  ]
                }`
              }
            },
            [
              createDate(item)
                .getDate()
                .toString(),
              sameDate(item, this.gd.start) || createDate(item).getDate() === 1
                ? h(
                    "div",
                    { class: { "gt-gantt-header-chunk-month": true } ,
                    // style: {width: this.colWidth*20+'px'}
                  },
                    
                    formatDate(createDate(item), "yyyy-MM")
                  )
                : null
            ]
          );
        })
        .concat(
          this.pd.ganttOptions[Variables.key.showToday] &&
            h("div", {
              class: { "gt-gantt-header-today-arrow": true },
              style: {
                left: `${this.todayLeft +
                  (this.colWidth - this.arrowWidth) / 2}px`,
                "border-width": `${this.arrowWidth / 2}px`,
                "border-top-color": this.pd.ganttOptions[Variables.key.body][
                  Variables.key.todayColor
                ]
              }
            })
        )
    );
  }
};
